export default __webpack_public_path__ + "static/media/MealPlanMobile_800.46d0e6a1.png";